import { useEffect } from "react";
import { toast } from "react-toastify";
import api from "utils/api";

export default function OtpToastNotifications() {
  useEffect(() => {
    let user;
    let permissions;
    try {
      user = JSON.parse(localStorage.getItem("user") || "null");
      permissions = JSON.parse(localStorage.getItem("allowedPermissions") || "null") || user?.permissions;
    } catch {
      return undefined;
    }
    const token = localStorage.getItem("token");
    if (!token || !["ADMIN", "SUPER_ADMIN"].includes(user?.role)) return undefined;
    const canReadOtpLogs = user.role === "SUPER_ADMIN" || (Array.isArray(permissions)
      ? permissions.includes("ALL") || permissions.includes("otpLogs")
      : permissions?.otpLogs?.get === true);
    if (!canReadOtpLogs) return undefined;

    let stopped = false;
    let initialized = false;
    let timer;
    let request;
    const seen = new Set();
    const notifications = new Set();

    const poll = async () => {
      if (stopped || localStorage.getItem("token") !== token) return;
      request = new AbortController();
      try {
        const response = await api.get("/auth/otp-logs", {
          params: { page: 1, limit: 200 },
          signal: request.signal,
          timeout: 15000,
        });
        if (stopped || localStorage.getItem("token") !== token) return;
        if (response.data?.success) {
          const logs = response.data.data?.logs || [];
          // The first successful request establishes a baseline, without replaying old OTPs.
          for (const log of [...logs].reverse()) {
            if (!log._id || seen.has(log._id)) continue;
            seen.add(log._id);
            const remaining = new Date(log.expiresAt).getTime() - Date.now();
            if (!initialized || !Number.isFinite(remaining) || remaining <= 0) continue;
            const toastId = `otp-log-${log._id}`;
            notifications.add(toastId);
            toast.info(
              <div>
                <div style={{ fontWeight: 600 }}>{log.type} OTP · {log.phone}</div>
                <div style={{ fontSize: "26px", fontWeight: 700, letterSpacing: "3px" }}>
                  {log.otp}
                </div>
              </div>,
              {
                toastId,
                autoClose: Math.min(30000, remaining),
                pauseOnHover: false,
                pauseOnFocusLoss: false,
                closeOnClick: false,
                onClose: () => notifications.delete(toastId),
              }
            );
          }
          initialized = true;
          // Keep only IDs in the latest result, so memory stays bounded.
          const latestIds = new Set(logs.map((log) => log._id));
          for (const id of seen) if (!latestIds.has(id)) seen.delete(id);
        }
      } catch (error) {
        if ([401, 403].includes(error.response?.status)) stopped = true;
      } finally {
        if (!stopped && localStorage.getItem("token") === token) {
          timer = setTimeout(poll, 5000);
        }
      }
    };

    poll();
    return () => {
      stopped = true;
      clearTimeout(timer);
      request?.abort();
      notifications.forEach((id) => toast.dismiss(id));
    };
  }, []);

  return null;
}
